module.exports = __webpack_public_path__ + "img/soccerboard90.eb171914.jpg";